import { render, staticRenderFns } from "./policyCheckInfor.vue?vue&type=template&id=46b0daeb&scoped=true"
import script from "./policyCheckInfor.vue?vue&type=script&lang=js"
export * from "./policyCheckInfor.vue?vue&type=script&lang=js"
import style0 from "./policyCheckInfor.vue?vue&type=style&index=0&id=46b0daeb&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b0daeb",
  null
  
)

export default component.exports